/*
 * The footer's reviews bar takes turns between its sources (Google, then
 * Trustpilot), as the live store's did (request 165). The row stays put: the
 * values that differ fade over and the stars re-fill (home.css). Paused on
 * hover, on keyboard focus and while the tab is hidden. One source alone
 * never moves.
 */
(function () {
  var bar = document.querySelector('[data-reviews-bar]');
  var row = bar && bar.querySelector('[data-reviews-row]');
  var brands = row ? (row.getAttribute('data-brands') || '').split(' ').filter(Boolean) : [];
  if (brands.length < 2) return;

  var index = 0;
  var paused = false;
  var seconds = parseInt(bar.getAttribute('data-interval'), 10) || 5;

  function show(i) {
    row.setAttribute('data-brand', brands[i]);
    row.querySelectorAll('[data-source]').forEach(function (el) {
      el.classList.toggle('is-active', el.getAttribute('data-source') === String(i));
    });
    row.querySelectorAll('[data-fill]').forEach(function (star) {
      var fills = star.getAttribute('data-fill').split(' ');
      star.style.setProperty('--reviews-fill', fills[i] || fills[0]);
    });
  }

  bar.addEventListener('mouseenter', function () { paused = true; });
  bar.addEventListener('mouseleave', function () { paused = false; });
  bar.addEventListener('focusin', function () { paused = true; });
  bar.addEventListener('focusout', function () { paused = false; });

  setInterval(function () {
    if (paused || document.hidden) return;
    index = (index + 1) % brands.length;
    show(index);
  }, seconds * 1000);
})();
